export default {
  hide() {}
};
